















import { Component, Vue } from 'vue-property-decorator'
import { WinckScreen } from '@/api/client/winck-proxy'
import { namespace } from 'vuex-class'
const narrowcasting = namespace('narrowcasting')

@Component
export default class CompanySettingsNarrowcastingInfo extends Vue {
    @narrowcasting.State readonly screens!: WinckScreen[]

    get urlToFeed(): string {
        return `https://src.marketingperron.nl/api/service/sam/wo?company=${this.$currentCompany.winckCompanyId}`
    }
}
